import React, { useEffect, useState } from "react";
import { Box, VStack, HStack, Text, Input } from "@chakra-ui/react";
import { searchColleagues } from "../../services/messagingService";
import SchemaBadge from "./SchemaBadge";

// Shared "search a colleague by name, scoped to their schema group, most recently active first" picker —
// used for starting a DM and for inviting someone to a private channel.
export default function UserSearchPicker({ schema, placeholder, autoFocus, onPick, onCancel }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return undefined;
    }
    const handle = setTimeout(async () => {
      try {
        const { users } = await searchColleagues(query, schema);
        setResults(users || []);
      } catch {
        setResults([]);
      }
    }, 250);
    return () => clearTimeout(handle);
  }, [query, schema]);

  return (
    <Box mb={2}>
      <Input
        size="sm"
        placeholder={placeholder || "Search people by name..."}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        autoFocus={autoFocus}
        onKeyDown={(e) => e.key === "Escape" && onCancel?.()}
      />
      {results.length > 0 && (
        <VStack align="stretch" mt={1} borderWidth="1px" borderRadius="md" maxH="160px" overflowY="auto">
          {results.map((u) => (
            <Box key={u.id} p={2} cursor="pointer" _hover={{ bg: "gray.50" }} onClick={() => onPick(u)}>
              <HStack spacing={2}>
                <Text fontSize="sm" minW={0} overflowWrap="anywhere">
                  {u.name || u.email}
                </Text>
                <SchemaBadge schema={u.current_schema} />
              </HStack>
              {u.name && u.email && (
                <Text fontSize="xs" color="gray.500">
                  {u.email}
                </Text>
              )}
            </Box>
          ))}
        </VStack>
      )}
    </Box>
  );
}
